/**
 * Business logic:
 * Print button is available for all users in Decision, CodeArticle and LawText documents.
 * In All other printable documents it is only available to paid users.
 * Except the PublicationSheet where the print button is only available to the internal users.
 * */
import { ModelType } from '@livv/models';

const isPdfExportAllowed = (
    modelType: ModelType,
    tier?: 'free' | 'paid',
    isInternalUser?: boolean,
): boolean => {
    switch (modelType) {
        case ModelType.DECISION:
        case ModelType.LAW_TEXT:
            return true;
        case ModelType.PUBLICATION_SHEET:
            if (isInternalUser === undefined) {
                console.error(
                    `isInternalUser flag is required for PDF Export of model type: ${modelType}`,
                );
            }

            return Boolean(isInternalUser); // only internal users
        case ModelType.ARTICLE:
        case ModelType.GLOSSARY_TERM:
        case ModelType.STATISTIC:
            if (!tier) {
                console.error(`User tier is required for PDF Export of model type: ${modelType}`);
            }

            return tier === 'paid'; // only paid users
        default:
            throw new Error(`Unknown PDF Export model type: ${modelType}`);
    }
};

export default isPdfExportAllowed;
